module.exports = __webpack_public_path__ + "img/confused.47d6c215.gif";